import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
let searchData = {
  Mail: '',
  IsAdmin:false,
  PageNumber: 1,
  PageSize: 25
};

let user = JSON.parse(localStorage.getItem("currentUser"));
export const AddMMPLUserDetails = (data) => {
  let url = `${API.PostMmplUser}`;
  return dispatch => {
    axios.post(url, data, {
      headers: {
        key: user.accessToken,
      }
    }).then((response) => {
      dispatch(getMMPLUsersList(searchData));
      dispatch({
        type: 'PostUserSuccess',
        data: response.data
      })
    }).catch((error) => {
      dispatch({
        type: 'PostUserFailure',
        data: "error"
      })
    })
  }
}
export const updateMMPLUserDetails = (data) => {
  let url = `${API.UpdateMmplUser}`;
  return dispatch => {
    axios.put(url, data, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        if(response.data){
        toast.success("Updated Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.history.goBack();
      }
        dispatch(getMMPLUsersList(searchData));
        dispatch({
          type: "UpdateUserSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "UpdateUserFailure",
          error: "ERROR"
        })
      })
  }
}
// export const DeleteMMPLUser = (id) => {
//   let url = `${API.UserAPI}/${id}`;
//   return dispatch => {
//     axios.delete(url)
//       .then((response) => {
//         dispatch(getMMPLUsersList(searchData));
//         dispatch({
//           type: "UserDeleteSuccess",
//           data: response.data
//         })
//       })
//       .catch((error) => {
//         dispatch({
//           type: "UserDeleteFailure",
//           error: "ERROR"
//         })
//       })
//   }
// }
export const getMMPLUsersList = (searchitem) => {
  let url = `${API.SearchMmplUser}?Mail=${searchitem.Mail}&PageNumber=${searchitem.PageNumber}&PageSize=${searchitem.PageSize}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getSearchMmplUserSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getSearchMmplUserFailure",
          error: "ERROR"
        })
      })
  }
}
export const getMMPLUsersDetails = (id) => {
  let url = `${API.GetMmplUserDetails}?MmplId=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getUserDetailsSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getUserDetailsFailure",
          error: "ERROR"
        })
      })
  }
}

